import React, { useState, useRef, useEffect } from 'react';
import InfoIcon from '../../../../Assets/Icons/Info.png';
import UserPrimaryInformationController from '../../../Controllers/AdminScreens/Users/UserPrimaryInformationController';
import Input from '../../../../Components/Input';
import Dropdown from '../../../../Components/Dropdown';
import DateInput from '../../../../Components/DateInput';
import LoadingSkeleton from '../../../../Components/LoadingSkeleton';
import Loader from '../../../../Components/Loader';
import MobileInput from '../../../../Components/MobileInput';
import { convertGMTToLocal } from '../../../../Utils/Validation';
import DeleteConfirmationModal from '../../../../Components/Modals/DeleteConformationModal';
import downArrow from '../../../../Assets/Icons/chevron-down.png';

const UserPrimaryInformationScreen = ({ isUserEditable, userInfo, loading, error, userActivityLoading, userActivityError, userActivityList, onRefresh }) => {
    console.log('userInfo in prime', userInfo)


    const { handleUpdateUser, handleCancel,
        fieldConfigs,
        primaryData,
        handleInputChange,
        updateDeleteError,
        updateDeleteSuccess,
        updateLoading,
        isEditModalOpen,
        handleOpenEditModal,
        handleCloseEditModal,
        callUpdateUser,
        getStatusStyle,
        visiblePages,
        currentTasks,
        currentPage,
        totalPages,
        handlePageChange,
        handleGetEmpPassword,
        passwordError,
        passwordLoading,
        password,
        passwordVisible,userPermissions
    } = UserPrimaryInformationController(userInfo, isUserEditable, userActivityList, onRefresh);
    //console.log('UserPrimaryInfo isUserEditable @@ ', isUserEditable, 'userInfo:-', primaryData)

    const [openDropdown, setOpenDropdown] = useState(null); // Tracks the currently open dropdown
    const toggleDropdown = (dropdownName) => {
        setOpenDropdown((prev) => (prev === dropdownName ? null : dropdownName));
    };
    const dropdownRefs = useRef({}); // Ref for dropdown
    const storedUserInfo = JSON.parse(localStorage.getItem("_userInfo_"));

    // Handle clicks outside dropdowns
    useEffect(() => {
        const handleClickOutside = (event) => {
            const isOutside = Object.keys(dropdownRefs.current).every(
                (key) => dropdownRefs.current[key] && !dropdownRefs.current[key].contains(event.target)
            );
            if (isOutside) {
                setOpenDropdown(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className='basic-info-container'>
            <h3 className='basic-info-header'>Basic Information</h3>
            <div className='basic-info-card'>
                <div className='form-grid'>
                    {fieldConfigs.map((field) => (
                        <div className="basic-info-item" key={field.key}>
                            {isUserEditable ? (
                                field.type === "dropdown" ? (
                                    <Dropdown
                                        ref={(el) => (dropdownRefs.current[`${field?.label}`] = el)}
                                        isOpen={openDropdown === `${field?.label}`}
                                        toggleDropdown={() => toggleDropdown(`${field?.label}`)}
                                        label={field?.label} // Dropdown already renders the label internally
                                        options={field.options}
                                        value={primaryData[field.key]}
                                        onChange={(selectedValue) => handleInputChange(field.key, selectedValue)}
                                        loading={field?.loading}
                                        errorMessage={field?.error}
                                        disabled={field?.label === 'Team Name' && primaryData['role_id'] === 102} 
                                    />
                                ) : field.type === "date" ? (
                                    <div className="basic-info-label">
                                        <label style={styles.label}>{field?.label}</label>
                                        <DateInput
                                            value={primaryData[field.key] || ""}
                                            onChange={(e) => handleInputChange(field.key, e.target.value)}
                                            errorMessage={field?.error}
                                        />
                                    </div>
                                ) : field.type === "display" ? (
                                    <><span className="basic-info-label">{field?.label}</span>
                                        {field.key === 'emp_mobile_no' ? <span> {primaryData?.emp_mobile_code}{primaryData[field.key]}{loading && <LoadingSkeleton width="40%" height="10px" />} </span> :
                                            <span className="basic-info-value"> {primaryData[field.key]} {!primaryData[field.key] && !loading && <span>--</span>} {loading && <LoadingSkeleton width="40%" height="10px" />}</span>}</>
                                ) : field.type === "mobile" ? (
                                    <MobileInput
                                        label={field?.label}
                                        countryCode={primaryData?.emp_mobile_code || ""}
                                        mobileNumber={primaryData[field.key] || ""}
                                        onCountryChange={(value) => handleInputChange("emp_mobile_code", value)}
                                        onMobileChange={(value) => handleInputChange(field.key, value)}
                                        placeholder={`Enter ${field?.label}`}
                                        countries={[
                                            { code: "IN", dialCode: "+91" },
                                            { code: "US", dialCode: "+1" },
                                            { code: "UK", dialCode: "+44" },
                                        ]}
                                        errorMessage={field?.error}
                                    />
                                ) : (
                                    <Input
                                        label={field?.label} // Input already renders the label internally
                                        // placeholder={`Enter ${field?.label}`}
                                        placeholder={
                                            (field?.label === 'Team Leader' || field?.label === 'Manager' || field?.label === 'Email ID')
                                                ? field?.label
                                                : `Enter ${field?.label}`
                                        }
                                        value={primaryData[field.key] || ''}
                                        onChange={(e) => handleInputChange(field.key, e.target.value)}
                                        isEdit={!(field?.label === 'Team Leader' || field?.label === 'Manager' || field?.label === 'Email ID')}
                                        errorMessage={field?.error}

                                    />
                                )
                            ) : (
                                <><span className="basic-info-label">{field?.label}</span>
                                    <span className="basic-info-value">
                                        {loading ? (
                                            <LoadingSkeleton width="40%" height="10px" />
                                        ) : (
                                            field.key === 'emp_mobile_no' ? <>{primaryData?.emp_mobile_code}{primaryData[field.key]}</> :
                                                field.key === "employee_join_at" ? (primaryData[field.key] ? convertGMTToLocal(primaryData[field.key], "dd/MM/yyyy") : '--') : (primaryData[field.key] || '--')
                                        )
                                        }
                                    </span></>
                            )}
                        </div>
                    ))}
                </div>
            </div>
            <div className="tasksScreen-task-table-wrapper" style={{ marginTop: 17 }}>
                <h3 className='basic-info-header'>Recent Activity</h3>
                <div className="basic-info-outer-card">
                    <table className='tasksScreen-task-table'>
                        <thead>
                            <tr>
                                <th style={{ width: "30%" }}>Task ID</th>
                                <th style={{ width: "50%" }}>Client</th>
                                <th style={{ width: "20%" }}>Current Status</th>
                            </tr>
                        </thead>
                        <tbody style={{ backgroundColor: 'white' }}>
                            {currentTasks?.map((task, index) => (
                                <tr>
                                    <td >{task?.task_id}</td>
                                    <td >{task?.client_name}</td>
                                    <td>
                                        <div
                                            style={{
                                                display: "inline-block",
                                                padding: "5px 10px",
                                                borderRadius: "15px",
                                                ...getStatusStyle(task), // Dynamic styles based on the status
                                                width: "auto", // Width adjusts automatically to content
                                            }}
                                        >
                                            {task?.task_status_name}

                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>

                    </table>
                    {userActivityError && <div className="list-error-msg">{userActivityError} </div>}
                    {userActivityLoading && <Loader loading={userActivityLoading} color={'var(--primary-loader-color)'} />}
                </div>
                <div className="tasksScreen-table-footer">
                    <span className="tasksScreen-pagination-info">
                        {`${currentPage}-${totalPages} of items`}
                    </span>
                    <div className="tasksScreen-pagination">
                        <button className="tasksScreen-pagination-button" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                            <img src={downArrow} alt="Previous" className="tasksScreen-arrow-left tasksScreen-icon-image " />
                        </button>
                        {visiblePages.map((page) => (
                            <button
                                key={page}
                                className={`tasksScreen-pagination-button ${currentPage === page ? "active" : ""}`}
                                onClick={() => handlePageChange(page)}
                            >
                                {page}
                            </button>
                        ))}
                        <button className="tasksScreen-pagination-button" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                            <img src={downArrow} alt="Next" className="tasksScreen-arrow-right tasksScreen-icon-image " />
                        </button>
                    </div>
                </div>
            </div>
            {updateDeleteError && <div className="list-error-msg"> {updateDeleteError} </div>}
            {updateDeleteSuccess && <div className="list-success-msg"> {updateDeleteSuccess} </div>}
            <div className="button-container" style={{ display: 'flex', justifyContent: 'space-between', marginTop: 20, flexWrap: 'wrap', gap: 20 }}>
            <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap' }}>
                {isUserEditable && <button onClick={handleUpdateUser} className="add-client-button" style={{ opacity: updateLoading ? 0.5 : 1, cursor: updateLoading ? 'not-allowed' : 'pointer' }}>
                    {updateLoading && (
                        <span style={{ paddingRight: 10 }}><Loader loading={updateLoading} color={'var(--background-color)'} size="small" /> </span>
                    )} Update User</button>}
                {isUserEditable &&
                    <button onClick={handleCancel} className="tasksScreen-cancel-button">Cancel</button>}
                </div>
                {isUserEditable && userPermissions?.emp_mgmt?.per_name_sub_json?.show_password === 1 && (
                    <div>
                        <button
                        onClick={() => {
                            if (primaryData.role_id_name === 'Super Admin' && storedUserInfo.emp_role !== 'Super Admin') {
                            return;
                            }
                            handleGetEmpPassword();
                        }}
                        className="tasksScreen-cancel-button"
                        disabled={passwordLoading}
                        >
                        {passwordLoading ? (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span style={{ paddingRight: 10 }}>
                                <Loader loading={passwordLoading} color={'var(--background-color)'} size="small" />
                            </span>
                            Showing Password
                            </div>
                        ) : password ? (
                            passwordVisible ? (
                            <span style={{ fontWeight: 'bold' }}>{password}</span>
                            ) : (
                            "Show Password"
                            )
                        ) : (
                            "Show Password"
                        )}
                        </button>
                    </div>
                    )}


            </div>
            {passwordError && <div className="list-error-msg" style={{textAlign:'right',padding:5}}>{passwordError} </div>}
            <DeleteConfirmationModal
                isOpen={isEditModalOpen}
                message={`Are you sure you want to update user ?`}
                onClose={handleCloseEditModal}
                onConfirm={() => {
                    handleCloseEditModal(); // Close modal
                    callUpdateUser();
                }}
            />

        </div>
    )

};

const styles = {
    container: {
        margin: "20px",
        //   fontFamily: "Arial, sans-serif",
        backgroundColor: '#fff',
        // marginTop: '-18px'
    },
    header: {
        fontSize: "18px",
        color: "var(--web-title-text-color)",
        marginBottom: "10px",
        fontWeight: 500,
        fontFamily: 'Roboto Slab'
    },
    card: {
        backgroundColor: "#fff",
        borderRadius: "5px",
        padding: "20px",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
        borderBottom: "2px solid black",
    },
    row: {
        display: "flex",
        flexWrap: "wrap",
        gap: "20px",
    },
    item: {
        flex: "1 1 calc(25% - 20px)",
        minWidth: "200px",
    },
    label: {
        fontSize: "12px",
        marginBottom: "5px",
        fontWeight: 400,
        fontFamily: "Roboto",
        color: "#343C44",
    },
    value: {
        fontSize: "14px",
        color: '#060606',
        fontWeight: 400,
        fontFamily: 'Roboto'
    },
    recentData: {
        color: '#B3261E',
        fontWeight: 400,
        fontSize: 12,
        fontFamily: 'Roboto'
    }
}

export default UserPrimaryInformationScreen;